import HeadSection from './sections/HeadSection';
import DeliveryAreaSection from './sections/DeliveryAreaSection';
import DeliveryDateSection from './sections/DeliveryDateSection';
import OrderSection from './sections/OrderSection';
import HelpSection from './sections/HelpSection';
import MainLayout from '../styles/MainLayout';

const Main = () => {
  return (
    <MainLayout>
      <HeadSection />
      <DeliveryAreaSection />
      <DeliveryDateSection />
      <OrderSection />
      <HelpSection />
    </MainLayout>
  );
};

export default Main;
